import { render } from "./ProfilePage.vue?vue&type=template&id=991a604c"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"
script.render = render

export default script